import { Element } from "@siteimprove/alfa-dom";
import { PseudoClassSelector } from "./pseudo-class.js";
const { isElement } = Element;
/**
 * {@link https://drafts.csswg.org/selectors/#last-child-pseudo}
 */
export class LastChild extends PseudoClassSelector {
    static of() {
        return new LastChild();
    }
    constructor() {
        super("last-child");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element) {
        return element
            .inclusiveSiblings()
            .filter(isElement)
            .last()
            .includes(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (LastChild) {
    LastChild.parse = PseudoClassSelector.parseNonFunctional("last-child", LastChild.of);
})(LastChild || (LastChild = {}));
//# sourceMappingURL=last-child.js.map